import {useStableRandom} from '@github-ui/use-stable-random'
import {LightBulbIcon} from '@primer/octicons-react'

import styles from './ReposListProTip.module.css'

const tips: React.FC[] = [
  () => (
    <>
      Using a comma within certain filters will aggregate the results. For example:&nbsp;
      <code className={styles.ProTipCode}>language:Go,Ruby</code> will show all repositories that have either Go or Ruby
      as their primary language.
    </>
  ),
  () => (
    <>
      When viewing an organization&apos;s repositories, you can use the{' '}
      <code className={styles.ProTipCode}>props.</code> filter to filter by custom property.
    </>
  ),
  () => <>Don&apos;t forget that you can create saved views to keep track of your most important repositories!</>,
]

export function ReposListProTip() {
  const tipIndex = useStableRandom({max: tips.length})
  const RandomTip = tips[tipIndex]

  if (!RandomTip) {
    return
  }

  return (
    <div className={styles.ProTipContainer}>
      <LightBulbIcon size={16} /> <strong className={styles.ProTip}>ProTip!</strong> <RandomTip />
    </div>
  )
}
